/* eslint-disable react-hooks/exhaustive-deps */
import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { GreenroomState } from '../../stores/types/types';
import { TABS } from '../../stores/types/tabs';
import Icon, { ICONS, COLORS } from '../general-components/icon';
import { MODAL_TEMPLATES } from '../../stores/reducers/modal';
import useDropArea from '../../hooks/use-dnd/use-drop-area';
import { DRAG_TYPE, DropCallback } from '../../stores/reducers/user-interface';

interface Props {
	dropCallback: DropCallback;
	feedPosition: number
}

export default function FeedPlaceholder(props: Props) {
	const {activeTab, rightDrawerOpen} = useSelector((s: GreenroomState) => s.TabsReducer);
	const embed = useSelector((state: GreenroomState) => state.SessionReducer.embed);
	const modalOpen = useSelector((state: GreenroomState) => state.ModalReducer.modalOpen);
	const modalTemplate = useSelector((state: GreenroomState) => state.ModalReducer.modalTemplate);
	const { dropCallback, feedPosition } = props;

	const emptyVideo = useMemo(() => {
		if ((activeTab === TABS.FEEDS || activeTab === TABS.MEDIA) && rightDrawerOpen) {
			return (
				<>
					<Icon name={
						activeTab === TABS.FEEDS
							? ICONS.ADD_INVITE
							: ICONS.ADD_CLOSE_CIRCLE
						}
						color={COLORS.GRAY}
						size={30}
					/>
					<span>Drag & Drop a {activeTab === TABS.FEEDS ? 'Feed' : 'Media File'}</span>
				</>
			);
		} if (modalOpen && modalTemplate === MODAL_TEMPLATES.SHOT_BUILDER) {
			return (
				<>
					<Icon
						name={activeTab === TABS.FEEDS
							? ICONS.ADD_INVITE
							: ICONS.ADD_CLOSE_CIRCLE
						}
						color={COLORS.GRAY}
						size={30}
					/>
					<span>Drag & Drop a New Feed</span>
				</>
			);
		}
		return <span>Open Feeds or Media Drawer</span>;
	}, [activeTab, rightDrawerOpen]);

	const { isOver, dropRef } = useDropArea({
		accepts: DRAG_TYPE.FEEDS,
		dropCallback,
		dropAreaData: { feedPosition },
	});

	return (
		<>
			{isOver && <div className="dnd-highlighted" />}
			<div ref={dropRef} className="empty-shot feed-drop-area">
					<div className="empty-shot">
						<div className="empty-video">
							{!embed && emptyVideo}
						</div>
					</div>
			</div>
		</>
	);
}
